"use client";

/**
 * NewForm DS hover icon — a plus for "create new".
 * On hover the cross rotates a quarter turn and springs back.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function PlusIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-plus">
        <path d="M12 5.2v13.6" />
        <path d="M5.2 12h13.6" />
      </g>
    </HoverIconSvg>
  );
}
